import Home from './Accueil'

export default Home